/**
 * Create a pseudo-random string for use as temporary IDs.
 */
export function createPseudoID() {
  return Math.floor(Math.random() * Math.pow(10, 15)).toString(16);
}
